// KL guide: inverter vs non-inverter aircond.
const content = {
    slug: 'inverter-vs-non-inverter-aircond',
    title: 'Inverter vs Non-Inverter Aircond in Malaysia | Cost and Servicing',
    description: 'Inverter vs non-inverter aircond in Malaysia: how they work, which saves more on your TNB bill, servicing differences, and when to upgrade.',
    eyebrow: 'KL · Aircond guide',
    h1: 'Inverter vs Non-Inverter Aircond: Which Is Better in Malaysia?',
    lead: 'Most new aircond sold in Malaysia is inverter, but many homes still run older non-inverter units. Here is what the difference means for your electricity bill, comfort and servicing.',
    datePublished: '2026-10-03',
    image: 'blog/living/panasonic-deluxe-inverter.jpg',
    imageAlt: 'Inverter aircond indoor unit',
    summary: {
        title: 'In short',
        items: [
            'Inverter units vary their speed; non-inverter units switch fully on and off.',
            'For bedrooms used every night, inverter usually costs less to run.',
            'Both need the same regular cleaning.',
            'Check the energy star label from Suruhanjaya Tenaga - more stars, more efficient.',
        ],
    },
    sections: [
        {
            title: 'How they work',
            cards: [
                { title: 'Non-inverter', body: 'The compressor runs at full speed until the room reaches the set temperature, switches off, then starts again when it warms up. The room swings warmer and colder.' },
                { title: 'Inverter', body: 'The compressor slows down as the room approaches the set temperature and keeps running gently. Steadier temperature, less wasted energy.' },
            ],
        },
        {
            title: 'Side by side',
            table: {
                columns: [
                    { key: 'topic', label: '' },
                    { key: 'inv', label: 'Inverter' },
                    { key: 'non', label: 'Non-inverter' },
                ],
                rows: [
                    { topic: 'Running cost (long hours)', inv: 'Lower', non: 'Higher' },
                    { topic: 'Purchase price', inv: 'Higher', non: 'Lower' },
                    { topic: 'Temperature', inv: 'Steady', non: 'Swings' },
                    { topic: 'Noise', inv: 'Quieter', non: 'Louder start-ups' },
                    { topic: 'Typical gas', inv: 'R32 (newer models)', non: 'R410A or R22 (older)' },
                    { topic: 'Repairs', inv: 'Boards cost more', non: 'Simpler, cheaper parts' },
                ],
            },
        },
        {
            title: 'Servicing differences',
            paragraphs: [
                'Cleaning is the same: filters every few weeks, a general service every three to four months, a chemical wash yearly. Inverter units are more sensitive to power surges - common during KL thunderstorms - so a surge-protected socket is a good idea. If an inverter unit shows a blinking error light, note the pattern for the technician.',
            ],
        },
        {
            title: 'When to upgrade',
            paragraphs: [
                'If your non-inverter unit is more than ten years old, uses R22 gas and runs every night, replacing it with a correctly sized inverter unit usually pays back through lower bills over a few years. For a guest room used occasionally, keep the old unit and just service it.',
            ],
        },
    ],
    faqs: [
        {
            question: 'Does inverter aircond really save electricity?',
            answer: 'For rooms used for long hours, yes - it avoids the repeated full-power start-ups of a non-inverter unit. For short daily use the saving is smaller.',
        },
        {
            question: 'Is servicing more expensive for inverter units?',
            answer: (c) => `No. A general service costs ${c.money(c.tables.general[0].wall)} for either type.`,
        },
    ],
    cta: {
        title: 'Keep either type efficient',
        body: 'A dirty coil wastes electricity on every kind of aircond.',
        href: '/my/aircond-service-kuala-lumpur/aircond-general-service',
        label: 'Book a general service',
    },
}

export default content
